<template>
  <v-card flat max-width="500" class="navigation-drawer">
    <v-navigation-drawer :value="navigationDrawer" app clipped floating mobile-breakpoint="1200" width="280">
      <v-list dense flat class="mt-2 ml-6">
        <v-subheader class="text-uppercase font-weight-medium ml-2 my-0">Menu</v-subheader>
        <span v-for="item in items" :key="item.title">
          <v-list-group
            :disabled="!dashboardNavItemCollapse"
            v-if="item && item.children"
            append-icon=""
            :value="dashboardNavItemCollapse ? true : false"
          >
            <template v-slot:activator>
              <v-list-item :to="item.route" link exact class="pl-0">
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </template>

            <!-- 2nd Group -->
            <!-- Import, Export -->
            <span v-for="it in item.children" :key="it.title">
              <v-list-group
                v-if="it && it.children"
                prepend-icon=""
                :disabled="!routeAreExportChildren"
                :value="routeAreExportChildren ? true : false"
                sub-group
              >
                <template v-slot:activator>
                  <v-list-item :to="it.route" exact link class="px-0">
                    <v-img v-if="it.type && it.type == 'image'" :src="it.imageUrl" contain height="35px" width="35px" />
                    <v-list-item-icon v-if="(it.type && it.type != 'image') || it.icon">
                      <v-icon>{{ it.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ it.title }}</v-list-item-title>
                  </v-list-item>
                </template>

                <!-- 3rd Group -->
                <!-- Exporter, COnsignee, I&P, F&I, Container, Shipment -->
                <span v-for="gc in it.children" :key="gc.title">
                  <v-list-group
                    v-if="gc.children"
                    prepend-icon=""
                    sub-group
                    :disabled="!routeAreInvoiceProductChildren"
                    :value="routeAreInvoiceProductChildren ? true : false"
                  >
                    <template v-slot:activator>
                      <v-list-item :to="gc.route" exact link class="pl-0">
                        <v-list-item-icon>
                          <v-icon>{{ gc.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ gc.title }}</v-list-item-title>
                      </v-list-item>
                    </template>

                    <!-- 4th Group -->
                    <!-- Add Invoice -->
                    <span v-for="gcc in gc.children" :key="gcc.title">
                      <v-list-item color="primary" :to="gcc.route" link>
                        <v-list-item-icon>
                          <v-icon>{{ gcc.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ gcc.title }}</v-list-item-title>
                      </v-list-item>
                    </span>
                  </v-list-group>
                  <v-list-item v-else color="primary" :to="gc.route" link>
                    <v-list-item-icon>
                      <v-icon>{{ gc.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>{{ gc.title }}</v-list-item-title>
                  </v-list-item>
                </span>
              </v-list-group>
              <v-list-item v-else color="primary" :to="it.route" link>
                <v-img v-if="it.type && it.type == 'image'" :src="it.imageUrl" contain height="35px" width="35px" />
                <v-list-item-title>{{ it.title }}</v-list-item-title>
              </v-list-item>
            </span>
          </v-list-group>

          <v-list-item v-else color="primary" :to="item.route" link>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </span>
      </v-list>

      <template v-slot:append>
        <div class="navigation-drawer__select-container d-xs-block d-sm-block d-md-none">
          <v-select
            v-model="timePeriod"
            single-line
            solo
            dense
            item-text="date"
            item-value="id"
            @change="updateTimePeriod"
            hide-details
            :menu-props="{ top: true, offsetY: true }"
            :items="timePeriods"
            label="Standard"
          ></v-select>
        </div>
        <v-divider class="my-3 d-xs-block d-sm-block d-md-none"></v-divider>
        <div class="navigation-drawer__menu-container text-center pb-4 d-xs-block d-sm-block d-md-none">
          <v-menu top offset-y attach>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs">
                <v-icon small left>fas fa-user-alt</v-icon>
                <span>{{ userName }}</span>
                <v-icon right>fas fa-caret-down</v-icon>
              </div>
            </template>
            <v-list style="z-index: 100;">
              <v-list-item @click="learnToUseDoc()">
                <v-list-item-title>Learn to use</v-list-item-title>
              </v-list-item>
              <v-list-item @click="icegateDigitalSign()">
                <v-list-item-title>Icegate Digital Sign</v-list-item-title>
              </v-list-item>
              <v-list-item @click="icegateLogin()">
                <v-list-item-title>Icegate Login</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('logout')">
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-navigation-drawer>
  </v-card>
</template>
<script>
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "NavigationDrawer",
  props: {
    items: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      mini: true,
      dashboardCollapse: false
    };
  },
  mixins: [commonMethodsMixin],
  mounted() {
    this.getUser();
    this.getTimePeriods();
    this.getGlobalTimePeriod();
  },
  computed: {
    routeIsImport() {
      return this.$route.name == "dashboard.import";
    },
    routeIsExport() {
      return this.$route.name == "dashboard.export";
    },
    routeIsImportOrExport() {
      return this.routeIsImport || this.routeIsExport;
    },
    routeAreExportChildren() {
      return this.$route.name.includes("dashboard.export.");
    },
    routeAreInvoiceProductChildren() {
      return this.$route.name.includes("dashboard.export.invoice-products.");
    },
    dashboardNavItemCollapse() {
      return this.routeIsImportOrExport || this.routeAreExportChildren || this.routeAreInvoiceProductChildren;
    }
  },
  methods: {}
};
</script>
<style lang="scss">
.navigation-drawer {
  &__select-container {
    max-width: 18rem;
    .v-input.theme--light.v-text-field.v-text-field--enclosed.v-select {
      .v-input {
        &__slot {
          box-shadow: none !important;
        }
      }
    }
  }
  &__menu-container {
    .v-menu.v-menu--attached {
      .v-menu__content {
        // top: 55px !important;
      }
    }
  }
}
</style>
